import styled, { css } from 'styled-components';
import { FlexBetween, FlexColumn } from '../../styled/common';
import { Breakpoints } from '../../styled/constants';

export const SearchContainer = styled(FlexColumn)<{
  $isSearchPage: boolean;
  $hasAuthHash: boolean;
}>`
  background-color: ${({ theme }) => theme.colors.background.primary};
  align-items: flex-start;
  width: 100%;
  padding: 0 15px;
  background-color: ${({ theme }) => theme.colors.background.primary};

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 0 40px;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding: 0 80px;

    ${({ $hasAuthHash }) =>
      !$hasAuthHash &&
      css`
        position: relative;
        z-index: 70000;
      `}
  }

  ${({ $isSearchPage }) =>
    $isSearchPage &&
    css`
      @media screen and (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
        padding: 0;
      }
    `}
`;

export const SearchBarForm = styled.form<{ isHomePage: boolean }>`
  width: 100%;

  @media screen and (min-width: ${({ theme }) =>
      theme.smallDesktopBreakpoint}) {
    padding-top: 10px;
  }

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const TopSearchLineContainer = styled(FlexBetween)`
  padding: 0 15px 15px;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding-right: 40px;
    padding-left: 40px;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding-right: 20px;
    padding-left: 20px;
  }

  .chips-container {
    margin-bottom: 0;
  }
`;

export const CategoriesContainer = styled(FlexBetween)`
  @media screen and (min-width: ${Breakpoints.desktop}px) {
    max-width: 1280px;
    margin: 0 auto;
  }
`;
